import type { IrrigationStatus, StatusPalette } from './riego.types';

export type { StatusPalette };

export const STATUS_COLORS: Record<IrrigationStatus, StatusPalette> = {
  scheduled: { fill: '#CFD8DC', border: '#B0BEC5' },
  proposal: { fill: 'rgba(206,147,216,0.35)', border: '#CE93D8', dashed: true },
  running: { fill: 'rgba(67,160,71,0.35)', border: '#1B5E20' },
  executedOk: { fill: '#1565C0', border: '#0D47A1' },
  stoppedByUser: { fill: '#F57C00', border: '#E65100' },
  failure: { fill: '#C62828', border: '#8E0000' },
  unknown: { fill: '#757575', border: '#757575' },
};

export const NOW_LINE = '#d32f2f';

export const RUNNING_SOLID = '#43A047';

export const RUNNING_TRACK = '#E0E4E7';

// Brand navy for pump-system headings.
export const BRAND_NAVY = '#003D7A';

// Shared chart/canvas colors (grid, axes, day labels, paper surface).
export const CHART_UI = {
  gridLine: '#EEF2F6',
  dayLabel: '#64748B',
  axisLabel: '#94A3B8',
  yAxisLabel: '#475569',
  paperBackground: '#FFFFFF',
  paperBorder: '#E2E8F0',
  paperShadow: '0 1px 2px rgba(15,23,42,0.04), 0 6px 16px -4px rgba(15,23,42,0.06)',
  chipBackground: '#f5f5f5',
  hoverBorder: '#212121',
  peakHourBand: 'rgba(255,152,0,0.12)',
} as const;

// Warm CTA for direct / irreversible irrigation actions (real commands).
export const CTA_ORANGE = {
  main: '#E07B39',
  hover: '#CF6E2E',
  contrastText: '#FFFFFF',
} as const;

// Peak-hour visual language (band, legend swatch, header chip).
export const PEAK_HOUR = {
  swatchFill: 'rgba(255,152,0,0.18)',
  border: '#FB8C00',
  text: '#E65100',
} as const;

// Shared radius scale across the operative dashboard surfaces.
export const RADIUS = {
  card: '14px',
  control: '8px',
  swatch: '4px',
  dialog: '16px',
} as const;

// Motion tokens. Strong ease-out for UI feedback; short durations only.
export const MOTION = {
  fast: '160ms',
  base: '200ms',
  ease: 'cubic-bezier(0.23, 1, 0.32, 1)',
} as const;

// Tooltip colors (header per kind, border, secondary text).
export const TOOLTIP_COLORS = {
  real: '#1565c0',
  scheduled: '#c2185b',
  border: '#bdbdbd',
  labelText: '#555',
} as const;

// Header background colors for the irrigation detail panel, keyed by kind/status.
// Reuses the tooltip's real/scheduled colors; proposal gets its own accent.
export const DETAIL_HEADER_COLORS = {
  proposal: '#8E24AA',
  scheduled: TOOLTIP_COLORS.scheduled,
  real: TOOLTIP_COLORS.real,
} as const;
